import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/fastpeps-core-storefront/src/components/auth-hide-chat.tsx");
